<div class="d-flex justify-content-center align-items-center auth-page">
  <div class="container d-flex flex-wrap">

    <!-- Form Section -->
    <div class="form">
      <div class="d-flex flex-column justify-content-center align-items-center h-100">
        <!-- Tablet-only welcome (md): shown over the background image; hidden on phone & desktop -->
        <div class="auth-tablet-welcome d-none d-md-block d-lg-none text-center mb-3">
          <h2 class="fw-bold mb-1">{{ 'auth.welcomeTitle' | transloco }}</h2>
          <p class="mb-0">{{ 'auth.welcomeSubtitle' | transloco }}</p>
        </div>
        <div class="login-container">
          <form #loginForm="ngForm" (ngSubmit)="login()">
            <img src="assets/login-example/images/AFP-logo-v02-400.png" style="width: 100%;" />
    
            <div class="form-group mt-4">
              <label for="username">{{ 'auth.username' | transloco }}</label>
              <input type="text" id="username" [(ngModel)]="loginModel.Username" [placeholder]="'auth.enterEmailOrUsername' | transloco"
                name="username" autocomplete="username" class="form-control" required />
            </div>
            <div class="form-group mt-2">
              <label for="password">{{ 'auth.password' | transloco }}</label>
              <div class="password-wrap">
                <input [type]="showPassword ? 'text' : 'password'" id="password" [(ngModel)]="loginModel.Password"
                  [placeholder]="'auth.enterPassword' | transloco" name="password" autocomplete="current-password"
                  class="form-control" required />
                <button type="button" class="toggle-password" (click)="showPassword = !showPassword"
                  [attr.aria-label]="(showPassword ? 'auth.hidePassword' : 'auth.showPassword') | transloco"
                  [attr.title]="(showPassword ? 'auth.hidePassword' : 'auth.showPassword') | transloco">
                  <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
            </div>
            <div class="form-group mt-3 remember-row">
              <input type="checkbox" id="rememberMe" name="rememberMe" [(ngModel)]="rememberMe" class="form-check-input m-0" />
              <label for="rememberMe" class="form-check-label mb-0">{{ 'auth.rememberMe' | transloco }}</label>
            </div>
            <div class="form-group text-center mt-3 mb-2">
              <div class="card flex justify-content-center">
                <button pButton type="submit" class="p-button-default p-button-outlined" [label]="'auth.login' | transloco"
                  [disabled]="!loginModel.Username || !loginModel.Password"></button>
              </div>
            </div>
            <div class="form-group text-center mt-2">
              <a href="javascript:void(0)" (click)="onForgotPasswordDialog()">{{ 'auth.forgotPassword' | transloco }}</a>
            </div>
            <div class="form-group text-center mt-2">
              <a [routerLink]="['/signup']">{{ 'auth.noAccountSignUp' | transloco }}</a>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Background Section (Hidden below lg so tablet gets a comfortable centred card) -->
    <div class="content d-none d-lg-block">
      <div class="background-loginPage d-flex align-items-center justify-content-center">
        <div class="text-center ">
          <h1 class="text-dark fw-bold">{{ 'auth.welcomeTitle' | transloco }}</h1>
          <p class="text-dark fw-bold">{{ 'auth.welcomeSubtitle' | transloco }}</p>
          <p class="text-dark fw-bold">{{ 'auth.alreadyMember' | transloco }}</p>
          <button class="btn btn-dark mt-3 px-4 py-2" [routerLink]="['/signup']">{{ 'auth.registerNow' | transloco }}</button>
        </div>
      </div>
    </div>

  </div>
</div>



  <!-- Forgot Password Dialog -->
  <p-dialog  [modal]="true" [(visible)]="showForgotPasswordDialog" [style]="{ 'width': '380px' }" (onHide)="closeDialog()">
    <form class="p-4">
      <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" style="width: 100%;" />
      <div class="form-group me-2 mt-4">
        <label for="email" class="form-label"><span class="text-danger">*</span> {{ 'auth.email' | transloco }}</label>
        <input type="email" id="email" name="email"
              class="form-control" [placeholder]="'auth.email' | transloco" [(ngModel)]="formData.Email" />
      </div>
      <div class="form-group text-sm mt-2">
        <span class="text-muted">
          <i class="fa fa-info-circle"></i>
          {{ 'auth.enterEmailAssociated' | transloco }}
        </span>
      </div>
      <div class="form-group text-center mt-4">
        <button pButton type="button" [label]="'auth.sendPasswordResetLink' | transloco" [disabled]="!formData.Email" class="p-button-primary p-button-outlined w-100" (click)="SendForgotPasswordMail()" ></button>
      </div>
    </form>
  </p-dialog>
  
